import axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import { CONFIG } from '@/constants/room.js';

const service = axios.create({
  baseURL: '',
  timeout: 30 * 1000,
  headers: {
    pragma: 'no-cache', // 防止IE缓存
    credentials: 'include', // 默认请求是否带上cookie
    formdata: 1,
  },
});

// const defaultPostHeader = {
//   "Content-Type": "application/json",
// };

// 请求前的统一处理
service.interceptors.request.use(
  async (config) => {
    // JWT鉴权处理

    const token = window.sessionStorage.getItem('xkb-livePlayer-token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.siteId = CONFIG.siteId;

    // let token = null;
    // try {
    //   token = await store.dispatch('user/trs_setToken');
    // } catch (error) {}
    // if (token) {
    //   config.headers.token = token;
    // } else {
    //   // window.setTimeout(() => {
    //   //   // 重定向到采编
    //   //   window.location.replace(window.location.origin + "/dist/");
    //   // }, 1000);
    // }

    // console.info('请求头',  config.headers)

    const _mehtod = config.method.toLocaleLowerCase();
    let params = null;
    switch (_mehtod) {
      case 'get':
        params = config.params;
        // console.log('get请求参数', params)
        break;
      case 'post':
        params = Object.assign({}, config.data);

        if (
          config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
        ) {
          config.data = qs.stringify(params);
        }

        break;
      default:
        break;
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    // const res = response.data
    const res = response;
    if (res.status === 200) {
      return res.data;
    }
    showError(res);
    return Promise.reject(res);
  },
  (error) => {
    console.error('请求出错：', error); // for debug
    if (error.response.status === 401) {
      return Promise.reject(error);
    }

    const badMessage = error.message || error;
    const code = parseInt(badMessage
      .toString()
      .replace('Error: Request failed with status code ', ''));
    showError({ code, message: badMessage });
    return Promise.reject(error);
  },
);

function showError(error) {
  // if (error.status === 403) {
  // to re-login
  // store.dispatch('user/loginOut');
  // } else {
  Message({
    message: error.msg || error.message || '服务异常',
    type: 'error',
    duration: 3 * 1000,
  });
  // }
}

export default service;
